module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h3', {
    staticClass: "grid__header"
  }, [_vm._v("you may also like")]), _vm._v(" "), _c('div', {
    staticClass: "grid__slider"
  }, [_c('div', {
    staticClass: "grid__listWrap"
  }, [_c('ul', {
    staticClass: "grid__list"
  }, _vm._l((_vm.products), function(item, index) {
    return (index !== _vm.mainProduct) ? _c('li', {
      staticClass: "grid__listItem",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.makeItomMain(index)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_c('img', {
      staticClass: "grid__img",
      attrs: {
        "src": './src/assets/' + item.imgMin,
        "alt": "item.header"
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "grid__price"
    }, [_c('span', {
      class: [_vm.products[index].newPrice == '' ? '' : 'grid__oldPrice']
    }, [_vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.products[index].price)) + " \n                  ")]), _vm._v(" "), (_vm.products[index].newPrice !== '') ? _c('span', {
      staticClass: "grid__newPrice"
    }, [_vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.products[index].newPrice)) + "\n                  ")]) : _vm._e()])])]) : _vm._e()
  }), 0)]), _vm._v(" "), (_vm.pageSize === 'S') ? _c('div', {
    staticClass: "grid__listControl"
  }, [_c('a', {
    staticClass: "grid__controlLink grid__controlLink_prev",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.sliderControl.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "grid__controlLink grid__controlLink_next",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.sliderControl.apply(null, arguments)
      }
    }
  })]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-317e13e9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/grid.vue
// module id = 50
// module chunks = 0